export default __webpack_public_path__ + "static/0129-8f1c275097e91437a659ac9c565fe006.png";